import api from '@/api/comment';
import syntheticImg from './drawing';
import messageApi from '@/utils/messagebox'
import {
	signTimeWordFromApi,
	updateQrcodeStatusFromApi,
	verifyTimeSignFromApi,
	getSealListFromApi,
	serializeSealListData,
} from './get-data';

let wait = false;
const noop = () => {};
const MSG = '接口数据异常';
const MSG2 = '需要emap-flow-comment组件实例';
// const MSG3 = '获取图片异常';
// const MSG4 = 'sealSid不能为空';
const errorImgBase64 = `data:image/png;base64,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`;

const createPromise = (statusFn) => {
	statusFn =
		statusFn ||
		((res, result) => {
			if (res.status != 0) {
				result.status = 2;
			}
		});
	return (apiFn, ...params) => {
		/**
		 * 0: 表示正常
		 * 2: 表示异常不用往下执行
		 */
		const result = {
			status: 0,
			data: null,
		};
		return apiFn
			.apply(null, params)
			.then((res) => {
				result.data = res;
				statusFn(res, result);
				return Promise.resolve(result);
			})
			.catch((err) => {
				result.status = 2;
				result.data = err;
				return Promise.resolve(result);
			});
	};
};

export default class Seal {
	constructor(options = {}) {
		this.sealConfig = options.sealConfig || {}; // getSealConfig.do 接口的完整返回值
		this.flowParams = options.flowParams || null; // getRenderFlowComponentParamsInForm.do 接口的完整返回值
		this.emapFlowCommentCpmponentVm = options.emapFlowCommentCpmponentVm; // emap-flow-comment.vue 组件实例
		this.mode = options.mode || 'default' // default: 可编辑 readonly: 没有意见框的模式

		this.getVerifyData = noop; // 获取表单字段及值得方法

		this.init();
	}

	init() {
		this._optionsVerify();
		this.getVerifyData = this.emapFlowCommentCpmponentVm.getVerifyData;
	}

	// 对options校验
	_optionsVerify() {
		const { sealConfig, emapFlowCommentCpmponentVm } = this;
		if (sealConfig.code !== '0') {
			throw new Error('[getSealConfig.do]: ' + MSG);
		}
		// if (!flowParams) { // 电子签章模式不走字段保护,该属性可有可无,所以不走校验
		// 	throw new Error('[getRenderFlowComponentParamsInForm.do]: ' + MSG);
		// }
		if (!emapFlowCommentCpmponentVm) {
			throw new Error('[emap-flow-comment.vue]: ' + MSG2);
		}
	}

	// 获取受保护的字段及值
	getProtectedValue(sfs) {
		if (this.mode === 'readonly') return encodeURI(JSON.stringify({}));
		const formData = JSON.parse(JSON.stringify(this.getVerifyData()));
		const securedFields = sfs || this.flowParams?.items?.securedFields || [];
		const map = securedFields.reduce((ret, key) => {
			ret[key] = formData[key] || '';
			return ret;
		}, {});
		return encodeURI(JSON.stringify(map));
	}

	_getCommonParams() {
		const getSealConfig = this.sealConfig.datas.getSealConfig;
		const host = getSealConfig.signatureHostUrl;
		const data = {
			appID: getSealConfig.signatureAppId,
			appSecret: getSealConfig.signatureSecret,
			id: getSealConfig.signatureUser,
		};
		return {
			host,
			data,
		};
	}

	handleSignTimeWord() {
		const { host, data } = this._getCommonParams();
		/**
		 * status
		 * 0: 表示不用调用 handleUpdateQrcodeStatus接口直接进行下一步
		 * 8: 表示需要调用handleUpdateQrcodeStatus接口
		 * 2: 表示异常不用往下执行
		 */
		return createPromise((res, result) => {
			if (res.status == 8 || res.status == 0) {
				result.status = res.status;
			} else {
				result.status = 2;
			}
		})(
			signTimeWordFromApi,
			host,
			Object.assign(data, {
				context: this.getProtectedValue(),
			})
		);
	}

	handleUpdateQrcodeStatus(transactionID) {
		const { host, data } = this._getCommonParams();

		return createPromise()(
			updateQrcodeStatusFromApi,
			host,
			Object.assign(data, {
				transactionID,
			})
		);
	}

	handleAddJGSeal(data, ret) {
		return createPromise((res, result) => {
			if (res.code != 0) {
				result.status = 2;
			}
		})(api.addJGSeal, {
			sealFile: data.downloadUrl,
			name: data.sealName,
			sid: data.sealId,
			mimetype: data.sealName + '.png',
			type: 4,
			signed: ret.data.signed,
		});
	}

	handleVerifyTimeSign(sealSigned, securedFields,userId) {
		const { host, data } = this._getCommonParams();
		return createPromise((res, result) => {
			if (res.msg == false) {
				result.status = 2;
			}
		})(
			verifyTimeSignFromApi,
			host,
			Object.assign(data, {
				id:userId,
				context: this.getProtectedValue(securedFields),
				signed: sealSigned,
			})
		);
	}

	getOriginImg(sealSid,userId) {
		const { host, data } = this._getCommonParams();
		return getSealListFromApi(host, Object.assign(data, {
			id:userId,
		}))
			.then((res) => {
				const obj = serializeSealListData(res).find(
					(item) => item.signid === sealSid
				);
				return obj?.downloadUrl || '';
			})
			.catch((e) => {
				console.error('未找到图片: ', e);
				return '';
			});
	}

	async getImgBase64(sealValid, sealSid,userId) {
		// sealValid: '0'使用错误合成图； 1使用原图
		const originImgBase64 = await this.getOriginImg(sealSid,userId);
		if (sealValid === '0') {
			return syntheticImg(originImgBase64, errorImgBase64, 2 / 3, 80);
		} else {
			return originImgBase64;
		}
	}

	/**
	 * 签名
	 * @param { getSignsignature 接口中的成员对象 } item
	 * @param {
	 *   回调函数:
	 *     第一个参数: null表示成功, 真值表示异常
	 *     第二个参数: 不同接口的返回值
	 * } callback
	 * @returns
	 */
	async sign(item, callback) {
		let result = await this.handleSignTimeWord();
		if (result.status === 8) {
			result = await this.handleUpdateQrcodeStatus(result.data.transactionID);
			console.log('诺安   :handleUpdateQrcodeStatus',result, result.status === 0);
			if (result.status === 0) {
				result = await this.handleSignTimeWord();
			} else if (result.status === 2) {
				return callback && callback(result.data);
			}
		} else if (result.status === 2) {
			return callback && callback(result.data);
		}

		if (result.status === 2) {
			return callback && callback(result.data);
		}

		result = await this.handleAddJGSeal(item, result);
		return (
			callback &&
			callback(result.status === 0 ? null : result.data, result.data)
		);
	}

	/**
	 * 图片签名检测
	 * @param { getFlowTaskComment.do 接口中的成员对象 } item
	 * @param {
	 *   回调函数:
	 *     第一个参数: 0表示成功, 1表示失败, 3表示更新, 4表示其他情况
	 *     第二个参数: verifyTimeSign接口的返回值或者updateJGSeal接口的返回值(只有3的时候)
	 *     第三个参数: 更新后的图片,用于更新视图
	 * } callback
	 * @params { 默认不自动验签 } autoCheck
	 * @returns undefined
	 */
	async checkSign(item, callback, autoCheck = false) {
		const { sealSigned, securedFields = [], sealValid, elecseal, sealSid,userId } = item;
		//const err = this?.$Message?.error || alert;
		if (!sealSid) {
			//err(MSG4)
			//messageApi(MSG4, 'error')
			return callback && callback('4');
		}
		let result = await this.handleVerifyTimeSign(sealSigned, securedFields,userId);
		const { status, data } = result;
		if (status === 0 && sealValid === '0') {
			// 直接展示接口的成功信息
			return callback && callback(autoCheck === false ? '0' : '4', data);
		} else if (status !== 0 && sealValid === '1') {
			// 直接展示接口的失败信息
			return callback && callback(autoCheck === false ? '1' : '4', data);
		} else {
			// 调用 updateJGSeal.do 接口更新
			const imgBase64 = await this.getImgBase64(sealValid, sealSid,userId);
			if (!imgBase64) {
				//err(MSG3);
				//messageApi(MSG3, 'error')
				return callback && callback('4');
			}
			result = await api.updateJGSeal({
				sealFile: imgBase64, // 最终图片（验签失败就是合成图   验签成功就是原图）
				wid: elecseal,
				valid: data.msg === true ? 0 : 1,
			});
			if (result && result.code === '0') {
				item.sealValid = data.msg === true ? '0' : '1' // 更新引用类型对象属性的状态值 vlid:0 有效, 1无效
				return callback('3', result, imgBase64);
			} else {
				//err(result.msg);
				messageApi(result.msg, 'error')
				return callback && callback('4');
			}
		}
	}

	/**
	 * @param { getFlowTaskComment.do 接口中的flowComment的值 } list
	 * @param { 每个验签结果的回调 } callback
	 * @returns
	 */
	async autoCheckAllSign(list, callback) {
		if (wait) return;
		wait = true;
		for (let i = 0; i < list.length; i++) {
			const item = list[i];
			await this.checkSign(item, callback, true);
		}
		wait = false;
	}
}
